<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<p-fieldset #pnl>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBackClose()"></button>
        </ng-template>

        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>

    <ng-template pTemplate="header">{{this.lbl_title}}</ng-template>




    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">
                    <!--div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            
                            <label for="opt">{{lbl_zone}}</label>
                            <div class="p-col-12 p-md-10">
                            <p-dropdown   [options]="listZones" [(ngModel)]="selectedZone"  optionLabel="descri" [showClear]="true" placeholder="{{lbl_select}} {{lbl_zone}}" (onChange)="loadNatios($event)"></p-dropdown>
                            </div>
                        </div>
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            <label for="opt">{{lbl_natio}}</label>
                            <div class="p-col-12 p-md-10">
                            <p-dropdown   [options]="listNatio" [(ngModel)]="selectedNatio"  optionLabel="descri" [showClear]="true" placeholder="{{lbl_select}} {{lbl_natio}}" (onChange)="loadLocals($event)"></p-dropdown>                                                
                        </div>
                        </div>
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            <label for="opt">{{lbl_local}}</label>
                            <div class="p-col-12 p-md-10">
                            <p-dropdown  [virtualScroll]="true" [options]="listLocal" [(ngModel)]="selectedLocal" itemSize="30" optionLabel="descri" [showClear]="true" placeholder="{{lbl_select}} {{lbl_local}}"></p-dropdown>
                        </div>
                        </div-->
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{lbl_period}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [virtualScroll]="true" [options]="listPeriods" [(ngModel)]="selectedPeriod"
                                itemSize="30" optionLabel="descrip" [showClear]="true"
                                (onChange)="getWorkShops()"
                                placeholder="{{lbl_select}} {{lbl_period}}"></p-dropdown>
                        </div>
                    </div>
                </div>
        <!--        <div class="p-field">
                    <button pButton icon="pi pi-search" pRipple label="{{lbl_search}}"  class="p-button-info p-mr-2"
                        (click)="getWorkShops()"></button>
                </div>  -->
            </div>
        </div>
    </div>




    <p-table #dt [value]="workShopsTracing" [rows]="20" [paginator]="true"
        [globalFilterFields]="['storeName','guideName','email','mobPhone']" [rowHover]="true" dataKey="guideId"
        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}" [showCurrentPageReport]="true"
        styleClass="p-datatable-responsive-demo">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{this.lbl_title}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">
                <!--button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button-->
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="storeName">{{lbl_coordination}}<p-sortIcon field="storeName"></p-sortIcon>
                </th>
                <th pSortableColumn="guideName">{{lbl_name}} {{lbl_contact}}<p-sortIcon field="guideName"></p-sortIcon>
                </th>
                <th pSortableColumn="email">{{lbl_email}}<p-sortIcon field="email"></p-sortIcon>
                </th>
                <th pSortableColumn="mobPhone">{{lbl_cell_phone}}<p-sortIcon field="mobPhone"></p-sortIcon>
                </th>
                <th pSortableColumn="wrksNum">{{lbl_number}} {{lbl_services}}<p-sortIcon field="wrksNum"></p-sortIcon>
                </th>
                <th pSortableColumn="participNum">{{lbl_number}} {{lbl_participants}}<p-sortIcon field="participNum"></p-sortIcon>
                </th>
                <th style="width:4rem"></th>
                <th style="width:4rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-wkrs>
            <tr>
                <td>{{wkrs.storeName}}</td>
                <td>{{wkrs.guideName}} {{wkrs.guideLastName}}</td>
                <td>{{wkrs.email}}</td>
                <td>{{wkrs.mobPhone}}</td>
                <td>{{wkrs.wrksNum}}</td>
                <td>{{wkrs.participNum}}</td>
                <td style="width:4rem">
                    <button type="button" pButton pRipple icon="pi pi-list" (click)="redirectDetail(wkrs)"></button>
                </td>
                <td style="width:4rem">
                    <button *ngIf="wkrs.storeType!='L'" type="button" pButton pRipple icon="pi pi-search" (click)="storeDrillDown(wkrs)"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{lbl_total}} {{workShopsTracing ? workShopsTracing.length : 0 }}  {{lbl_records}}.
            </div>
        </ng-template>
    </p-table>

</p-fieldset>